export const SENTRY_DSN =
  process.env.SENTRY_DSN ||
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  'https://ba29fb83a0140228ab7ad7d4ef0edb09@o1331173.ingest.us.sentry.io/4508415838388225'

const env = process.env.NEXT_PUBLIC_ENV || ''
const sentryBlackList = ['local']
export const isSentryEnabled = !sentryBlackList.includes(env)
